import { apiResourceUrl } from "@ploy-lib/core";
import { BaseCamelCasedResource } from "./BaseResource";
export class BankIntentionResource extends BaseCamelCasedResource {
    constructor() {
        super(...arguments);
        this.applicationId = 0;
        this.supplierId = 0;
    }
    pk() {
        return this.applicationId?.toString() || "";
    }
}
BankIntentionResource.urlRoot = apiResourceUrl("bank-intention");
export class SendBankIntentionResource extends BankIntentionResource {
}
SendBankIntentionResource.urlRoot = apiResourceUrl("bank-intention/send");
//# sourceMappingURL=BankIntentionResource.js.map